/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { BasicFilter, Search, TOOLBAR_ITEM_TYPE, TOOLBAR_VIEW_TYPE } from '@veeam-vspc/components';
import { capitalize } from '@veeam-vspc/core';
import { Vb365Job } from '@veeam-vspc/models/rest';

import { useLang } from 'views/providers/LangProvider/hooks';
import { AdvancedToolbar } from 'views/components/AdvancedToolbar';
import { StatusToggleFilter } from 'views/components/filters/StatusToggleFilter';
import backupJobIcon from 'images/filters/vb365-job-types/backup.svg';
import backupCopyJobIcon from 'images/filters/vb365-job-types/backup-copy.svg';

export const VBObjectsFilterToolbar: React.FC = () => {
    const lang = useLang();

    const statuses = [
        { title: lang.SUCCESS, value: Vb365Job.LastStatusEnum.Success },
        { title: lang.WARNING, value: Vb365Job.LastStatusEnum.Warning },
        { title: lang.FAILED, value: Vb365Job.LastStatusEnum.Failed },
        { title: lang.RUNNING, value: Vb365Job.LastStatusEnum.Running },
        {
            title: lang.INFORMATION,
            value: [
                Vb365Job.LastStatusEnum.Unknown,
                Vb365Job.LastStatusEnum.NotConfigured,
                Vb365Job.LastStatusEnum.Disconnected,
                Vb365Job.LastStatusEnum.Stopped,
                Vb365Job.LastStatusEnum.Queued,
            ],
        },
    ];

    return (
        <AdvancedToolbar
            view={TOOLBAR_VIEW_TYPE.spotted}
            items={[
                {
                    type: TOOLBAR_ITEM_TYPE.customControl,
                    render: () => (
                        <Search
                            name='name'
                            placeholder={lang.JOB}
                            hasSearchButton={true}
                            maxLength={128}
                        />
                    ),
                },
                {
                    type: TOOLBAR_ITEM_TYPE.customControl,
                    render: () => (
                        <Search
                            name='vb365ServerName'
                            placeholder={lang.SERVER}
                            hasSearchButton={true}
                            maxLength={255}
                        />
                    ),
                },
                {
                    type: TOOLBAR_ITEM_TYPE.customControl,
                    render: () => (
                        <StatusToggleFilter
                            propName='lastStatus'
                            statuses={statuses}
                        />
                    ),
                },
                {
                    type: TOOLBAR_ITEM_TYPE.customControl,
                    render: () => (
                        <BasicFilter
                            label={lang.TYPE}
                            hasAllButton
                            name='jobType'
                            buttons={[
                                {
                                    icon: backupJobIcon,
                                    value: Vb365Job.JobTypeEnum.BackupJob,
                                    title: lang.BACKUP,
                                },
                                {
                                    icon: backupCopyJobIcon,
                                    value: Vb365Job.JobTypeEnum.CopyJob,
                                    title: capitalize(lang.BACKUP_COPY),
                                },
                            ]}
                        />
                    ),
                },
            ]}
        />
    );
};

